import React from 'react'
import { styled } from '@mui/system'
import PwsLogo from '../../img/logo_powerspace_spinner.svg?react'
import { getActiveSeasonalPeriod, SeasonalPeriod } from '../layout/seasonalPeriods'

const DivContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  height: '100%',
  alignItems: 'center',
  flexGrow: 1,
}))

const seasonalPalettes: Record<SeasonalPeriod, readonly [string, string, string, string]> = {
  halloween: ['#ff6d00', '#7b1fa2', '#ffb300', '#3e2723'],
  christmas: ['#d32f2f', '#2e7d32', '#fbc02d', '#f5f5f5'],
  'new-year': ['#f9a825', '#90caf9', '#5e35b1', '#eceff1'],
  easter: ['#f48fb1', '#fff176', '#81d4fa', '#aed581'],
  valentine: ['#d81b60', '#ff80ab', '#ef5350', '#ad1457'],
  bastille: ['#ef4135', '#ffffff', '#0055a4', '#ffffff'],
}

const defaultPalette = ['#ff008e', '#ffde00', '#7cc90c', '#009ee2'] as const

const RotatingLogo = styled(PwsLogo, {
  shouldForwardProp: (property) => property !== 'seasonalPeriod',
})<{ seasonalPeriod: SeasonalPeriod | null }>(({ seasonalPeriod }) => {
  const palette = seasonalPeriod ? seasonalPalettes[seasonalPeriod] : defaultPalette

  return {
    width: '50px',
    height: '50px',
    animation: 'spin 0.7s linear infinite',
    ...(seasonalPeriod === 'bastille' && {
      overflow: 'visible',
      '& path': {
        stroke: '#757575',
        strokeWidth: '1.25px',
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        paintOrder: 'stroke fill',
      },
    }),
    '& path:nth-of-type(1)': { fill: palette[0] },
    '& path:nth-of-type(2)': { fill: palette[1] },
    '& path:nth-of-type(3)': { fill: palette[2] },
    '& path:nth-of-type(4)': { fill: palette[3] },
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  }
})

export const PwsSpinner: React.FC<{ period?: SeasonalPeriod | null; seasonalChance?: number }> = ({
  period,
  seasonalChance = 0.5,
}) => {
  const activePeriod = period === undefined ? getActiveSeasonalPeriod() : period
  const [showSeasonalImage] = React.useState(() => Math.random() < seasonalChance)
  const imagePeriod = showSeasonalImage ? activePeriod : null

  return (
    <DivContainer
      data-testid="pwsSpinner"
      data-seasonal-period={activePeriod ?? undefined}
      data-spinner-image={imagePeriod ?? 'default'}
    >
      <RotatingLogo seasonalPeriod={imagePeriod} />
    </DivContainer>
  )
}

export default PwsSpinner
